import { DatePipe } from '@angular/common';
import { NgModule, Optional, SkipSelf } from '@angular/core';
import { AuthorizationGuard } from '@guards/authorization.guard';
import { AddressPipe } from '@pipes/address.pipe';
import { AsciiPipe } from '@pipes/ascii.pipe';
import { PhonePipe } from '@pipes/phone.pipe';
import { NamePipe } from './pipes/name.pipe';
import { SignedNumberPipe } from './pipes/signed-number.pipe';
import { TimespanPipe } from './pipes/timespan.pipe';
import { WeekPipe } from './pipes/week.pipe';
import { LanguagePipe } from './pipes/language.pipe';

@NgModule({
  imports: [],

  declarations: [
    AddressPipe,
    AsciiPipe,
    PhonePipe,
    NamePipe,
    SignedNumberPipe,
    TimespanPipe,
    WeekPipe,
    LanguagePipe,
  ],

  providers: [
    AuthorizationGuard,
    AddressPipe,
    AsciiPipe,
    PhonePipe,
    DatePipe,
    NamePipe,
    SignedNumberPipe,
    TimespanPipe,
    WeekPipe,
    LanguagePipe
  ],
  exports: [
    AddressPipe,
    AsciiPipe,
    PhonePipe,
    NamePipe,
    SignedNumberPipe,
    TimespanPipe,
    WeekPipe,
    LanguagePipe
  ]
})
export class CoreModule {
  constructor( @Optional() @SkipSelf() parentModule: CoreModule) {
    throwIfAlreadyLoaded(parentModule, 'CoreModule');
  }
}

export function throwIfAlreadyLoaded(parentModule: any, moduleName: string) {
  if (parentModule) {
    throw new Error(`${moduleName} has already been loaded. Import Core modules in the AppModule only.`);
  }
}
